import { formatPrice } from 'src/utils';

type Props = {
  amount: number;
  locale: string;
  ccy: string;
  ccys: string;
};

// w-0 min-w-full: sized by the price below it, so the amount never widens the price column;
// justify-end makes a wider amount overflow leftward, toward the row, instead of past its right edge.
export const AmazonDealBasis = ({ amount, locale, ccy, ccys }: Props) => (
  <p className='flex w-0 min-w-full animate-fadeIn justify-end whitespace-nowrap text-xs text-standardGray line-through'>
    {formatPrice(amount, locale, ccy, ccys, false)}
  </p>
);
